"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InventoryAdjustmentInfoStatus;
(function (InventoryAdjustmentInfoStatus) {
    InventoryAdjustmentInfoStatus["Created"] = "Created";
    InventoryAdjustmentInfoStatus["Deleted"] = "Deleted";
    InventoryAdjustmentInfoStatus["Finished"] = "Finished";
})(InventoryAdjustmentInfoStatus = exports.InventoryAdjustmentInfoStatus || (exports.InventoryAdjustmentInfoStatus = {}));
